import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';

const ResetPasswordForm = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [status, setStatus] = useState({ message: '', type: '' });

  const email = params.get('email');
  const token = params.get('token');

  const styles = {
    background: {
      minHeight: '100vh',
      backgroundImage:
        'url("https://a0.muscache.com/im/pictures/miso/Hosting-1205138042877593664/original/0d94964b-e1b9-4c9a-bafa-d9f8632dcc9d.jpeg?im_w=720")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
    },
    container: {
      maxWidth: '400px',
      width: '100%',
      padding: '30px',
      borderRadius: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Segoe UI, sans-serif',
    },
    heading: {
      textAlign: 'center',
      marginBottom: '20px',
      fontSize: '22px',
    },
    iconInputGroup: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#f1f1f1',
      borderRadius: '6px',
      border: '1px solid #ccc',
      marginBottom: '16px',
    },
    icon: {
      padding: '10px',
      backgroundColor: '#e9e9e9',
      borderRight: '1px solid #ccc',
      borderTopLeftRadius: '6px',
      borderBottomLeftRadius: '6px',
      fontSize: '16px',
      color: '#007bff',
    },
    inputField: {
      flex: 1,
      border: 'none',
      outline: 'none',
      fontSize: '15px',
      padding: '12px',
      background: 'transparent',
    },
    button: {
      width: '100%',
      padding: '12px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      fontWeight: 'bold',
      fontSize: '16px',
      cursor: 'pointer',
    },
    message: {
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '15px',
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ message: '', type: '' });

    try {
      const res = await fetch('https://ikaze-thouse-backend.vercel.app/api/v1/auth/password-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token, newPassword }),
      });

      const data = await res.json();
      if (data.success) {
        setStatus({ message: data.message, type: 'success' });
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setStatus({ message: data.message, type: 'error' });
      }
    } catch (err) {
      console.error('Reset error:', err);
      setStatus({ message: 'Something went wrong.', type: 'error' });
    }
  };

  useEffect(() => {
    if (!email || !token) {
      setStatus({ message: 'Invalid or missing token.', type: 'error' });
    }
  }, [email, token]);

  return (
    <div style={styles.background}>
      <div style={styles.container}>
        <h2 style={styles.heading}>Reset Password</h2>
        {status.message && (
          <p style={{ ...styles.message, color: status.type === 'success' ? 'green' : 'red' }}>
            {status.message}
          </p>
        )}
        <form onSubmit={handleSubmit}>
          <div style={styles.iconInputGroup}>
            <div style={styles.icon}>
              <FaLock />
            </div>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={styles.inputField}
            />
          </div>
          <button type="submit" style={styles.button}>
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
